var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalFunding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1481"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.325 17.15h1.5v-1.125h1.2a.746.746 0 00.613-.3 1.06 1.06 0 00.238-.675v-2.875a1.045 1.045 0 00-.238-.688.758.758 0 00-.613-.287h-3.4V9.475h4.25v-1.5h-2.05V6.85h-1.5v1.125H10.1a.933.933 0 00-.675.3.959.959 0 00-.3.7v2.85a.771.771 0 00.3.637 1.06 1.06 0 00.675.237h3.275v1.825h-4.25v1.5h2.2zM3.5 20a1.439 1.439 0 01-1.05-.45A1.439 1.439 0 012 18.5v-13a1.439 1.439 0 01.45-1.05A1.439 1.439 0 013.5 4h17A1.538 1.538 0 0122 5.5v13a1.538 1.538 0 01-1.5 1.5zm0-1.5h17v-13h-17zm0 0z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 363",
    fill: "none",
    d: "M0 0h24v24H0z"
  }))));
}
export default SvgTotalFunding;